import React, { useEffect } from "react";
import { ListContextProvider, useListContext } from "react-admin";
import { useHistory } from "react-router-dom";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
import CustomLinearProgress from "../../../../../Components/Progress/LinearProgress";
import OpenRequestsDataGrid from "./OpenRequestsDataGrid";
import WaitingPoolScopeDataGrid from "./WaitingPoolScopeDataGrid";
import UnshippedSvcDataGrid from "./UnshippedSvcDataGrid";
import PbhReserved from "./PbhReserved";
import ShippingProcess from "./ShippingProcess";
import RejectionProposalDataGrid from "./RejectionProposalDataGrid";
import LocalRepairDataGrid from "./LocalRepairDataGrid";
import SuspendedRequestsDataGrid from "./SuspendedRequestsDataGrid";
import { makeStyles } from "@material-ui/core";
import RequirementCategory from "../../../../../Enums/RequirementCategory";
import { CustomPbhRequestListFilterEnum } from "../../../../../Enums/CustomPbhRequestListFilterEnum";
import { useAuth } from "@airborne/react-admin";

const useStyles = makeStyles({
  datagrid: {
    "& .MuiTableCell-root": {
      padding: "0px !important", // Hücreler arasındaki padding'i sıfırlar
      marginLeft: "0px !important",
      marginRight: "0px !important",
    },
    "& .MuiTableCell-head": {
      padding: "0px 2px 0px 2px !important", // Başlık hücreleri için padding'i sıfırlar
    },
    "& .MuiTableCell-body": {
      padding: "0px", // Gövde hücreleri için padding'i sıfırlar
      color: "unset !important",
    },
    "& .MuiTableCell-sizeSmall": {
      padding: "0px 2px 0px 2px !important", // Gövde hücreleri için padding'i sıfırlar
    },
  },
});
export const PbhRequestOrderDataGrid = props => {
  const classes = useStyles();
  const listContext = useListContext();
  const history = useHistory();
  const { user } = useAuth();
  const { record, requestStatus, isXSmall, setActiveTab, createId, reloadTabs, ...rest } = props;
  const { ids, filterValues, setFilters, displayedFilters, loading, data } = listContext;

  useEffect(() => {
    const customFilter = filterValues?.customFilter__eq ?? CustomPbhRequestListFilterEnum.ThirdParty;

    const hasCorrectStatusFilter =
      requestStatus === PbhRequestStatus.UnshippedSvc
        ? Array.isArray(filterValues?.requestStatus__in) &&
          filterValues.requestStatus__in.includes(PbhRequestStatus.UnshippedSvc)
        : filterValues?.requestStatus__eq === requestStatus;

    if (hasCorrectStatusFilter) return;

    if (requestStatus === PbhRequestStatus.UnshippedSvc) {
      setFilters(
        {
          requestStatus__in: [
            PbhRequestStatus.UnshippedSvc,
            PbhRequestStatus.AlternatePnOffered,
            PbhRequestStatus.AlternatePnAccepted,
            PbhRequestStatus.AlternatePnRejected,
          ],
          customFilter__eq: customFilter,
        },
        displayedFilters
      );
    } else if (requestStatus === PbhRequestStatus.WaitingPoolScope) {
      setFilters(
        {
          requestStatus__eq: requestStatus,
          customFilter__eq: customFilter,
          [`!(access = false && repair = true) || (isLocalRepair = true)`]: "test",
        },
        displayedFilters
      );
    } else {
      setFilters({ requestStatus__eq: requestStatus, customFilter__eq: customFilter }, displayedFilters);
    }
  }, [requestStatus]);

  useEffect(() => {
    if ((history as any)?.location?.state?.requestStatus__eq) {
      setFilters({ ...filterValues, ...(history as any)?.location?.state }, displayedFilters);
      setActiveTab((history as any)?.location?.state?.requestStatus__eq);
      history.replace({
        pathname: `/pbhrequestorders/list`,
        state: {},
      });
    }
  }, []);
  const rowStyle = (record, index) => {
    if (record.requirementCategoryText === RequirementCategory.AOG) {
      return { color: "red" }; // Status 'x' ise kırmızı metin rengi
    }
    return { color: "black" }; // Diğer durumlarda siyah metin rengi
  };

  return (
    <>
      {isXSmall ? (
        <ListContextProvider {...rest} value={{ ...listContext, ids: ids }}>
          <></>
        </ListContextProvider>
      ) : (
        <ListContextProvider
          {...rest}
          value={{
            ...listContext,
            ids: ids,
          }}
        >
          <CustomLinearProgress loading={loading} periodTime={500} />
          {!loading && requestStatus === PbhRequestStatus.Open && (
            <OpenRequestsDataGrid {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
          {!loading && requestStatus === PbhRequestStatus.WaitingPoolScope && (
            <WaitingPoolScopeDataGrid {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
          {!loading && requestStatus === PbhRequestStatus.UnshippedSvc && (
            <UnshippedSvcDataGrid {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
          {!loading && !user?.isCustomer && requestStatus === PbhRequestStatus.Reserved && (
            <PbhReserved {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
          {!loading && requestStatus === PbhRequestStatus.ShippingProcess && (
            <ShippingProcess {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
          {!loading && requestStatus === PbhRequestStatus.RejectionProposal && (
            <RejectionProposalDataGrid {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
          {!loading && requestStatus === PbhRequestStatus.LocalRepair && (
            <LocalRepairDataGrid {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
          {!loading && requestStatus === PbhRequestStatus.Suspended && (
            <SuspendedRequestsDataGrid {...props} rowStyle={rowStyle} reloadTabs={reloadTabs} classes={classes} />
          )}
        </ListContextProvider>
      )}
    </>
  );
};

export default PbhRequestOrderDataGrid;
